 import { Component, OnInit, Input } from '@angular/core';
import { Guest, GuestService, GuestRoleService, RoleService, NotificationDialogComponent } from 'app/shared';
import { GuestRole } from 'app/shared/models/guest-role.model';
import { Role } from 'app/shared/models/role.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from 'app/shared/services/validation.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-edit-guest',
    templateUrl: './edit-guest.component.html',
    styleUrls: ['./edit-guest.component.scss'],
    standalone: false
})
export class EditGuestComponent implements OnInit {
  roles: Role[];

  guestRoleId: number;
  guestRole: GuestRole;
  otherGuestRoles: GuestRole[];
  role: Role;

  guestADAccountExists: boolean = false;
  guestRoleHasADAccount: boolean = false;


  currentDate: Date = new Date();
  endDate: Date;
  startDate: Date;

  spinner: boolean = false;
  loading: boolean;
  guestInfoLoading: boolean;
  guestRoleLoading: boolean;
  editUserInfo: boolean;

  constructor(
    private guestService: GuestService,
    private guestRoleService: GuestRoleService,
    private roleService: RoleService,
    private route: ActivatedRoute,
    private router: Router,
    private validationService: ValidationService,
    public dialog: MatDialog,
    ) { }

  ngOnInit() {
    this.editUserInfo = false;
    this.route.paramMap.subscribe(params => {
      this.guestRoleId = parseInt(params.get("guestRoleId"))
      this.getRoles();
      this.getGuestRole();
    })
  }

  getRoles() {
    this.roleService.getRolesByUser().subscribe(
      roles => {
        this.roles = roles;
      }
    )
  }

  getGuestRole() {
    this.guestRoleService.getGuestRoleById(this.guestRoleId).subscribe({
      next: guestRole => {
        this.guestRole = guestRole;
        this.endDate = new Date(this.guestRole.endDate);
        this.startDate = new Date(this.guestRole.startDate);
        this.guestRoleHasADAccount = this.guestRole.activeDirectoryAccount;
        this.getGuestADAccountExists(this.guestRole.guest.iNumber);
        this.otherGuestRoles = this.guestRole.guest.guestRoles.filter(gr => gr.guestRoleId != this.guestRoleId);
        if(guestRole.guest.existingNotGuestAccount) {
          this.editUserInfo = false;
        }
        this.role = this.roles?.find(r => r.roleId == this.guestRole.roleId);
      },
      error: e => {
        // this.router.navigate(['unauthorized'])
      }
    })
  }

  getGuestADAccountExists(iNumber: string) {
    if (!iNumber)
      return

    this.guestService.checkIfActiveDirectoryAccountExists(iNumber).subscribe({
      next: account => this.guestADAccountExists = account.adAccountExists,
      error: e => this.guestADAccountExists = false
    })
  }

  confirmPasswordReset(){
    var confirmMessage = `Would you like to send a password reset email to ${this.guestRole.guest.fullName} (${this.guestRole.guest.email})?`;

    let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Password Reset',
        content: confirmMessage,
        confirm: 'Send Password Reset Email'
      }
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.sendPasswordResetEmail();
        }
      }
    );
  }

  sendPasswordResetEmail(){
    this.spinner = true;
    let successMessage = `Password reset email successfully sent to ${this.guestRole.guest.fullName} (${this.guestRole.guest.email})`;
    let errorMessage = `Unable to send password reset email to ${this.guestRole.guest.fullName} (${this.guestRole.guest.email})`;
    this.guestService.sendPasswordResetEmail(this.guestRole.guest.iNumber).subscribe({
      next: success => {
        let message = success ? successMessage : errorMessage;
        this.spinner = false;
        alert(message);
      },
      error: e => {
        alert(errorMessage);
        this.spinner = false;
      },
      complete: () => this.spinner = false
    });
  }

  confirmResetAccountSetup() {
    var confirmMessage = `Would you like to reset AD account activation attempts for ${this.guestRole.guest.fullName} (${this.guestRole.guest.email})?`;

    let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Reset Activation Attempts',
        content: confirmMessage,
        confirm: 'Reset Activation Attempts'
      }
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.resetGuestAttemptCount();
        }
      }
    );
  }

  resetGuestAttemptCount(){
    this.guestService.resetGuestAttemptCount(this.guestRole.guestId).subscribe();
  }

  saveGuestRoleInfo() {
    this.guestRoleLoading = true;
    let validRole = this.validationService.validateGuestRole(this.guestRole);

    if (validRole) {
      this.guestRoleService.updateGuestRole(this.guestRole).subscribe({
        next: results => {
          this.guestRoleLoading = false;
          this.openNotificationDialog("Guest Account Updated", "Guest account successfully updated.");
        },
        error: e => {
          this.guestRoleLoading = false;
          this.openNotificationDialog("Guest Account Not Updated", e.error.message);
        }
      });
    } else {
      this.openNotificationDialog("Guest Account Not Updated", "Invalid. Please fill all required fields and resubmit.");
    }
  }

  getButtonChangeEvent($event) {
    this.editUserInfo = $event;
  }

  openNotificationDialog(titleMessage: string, contentMessage: string) {
    const notificationDialog = this.dialog.open(NotificationDialogComponent, {
      data: {
        title: titleMessage,
        content: contentMessage,
      }
    });

    notificationDialog.afterClosed().subscribe(
      result => {
      }
    );
  }
}
